module.exports = __webpack_public_path__ + "img/51626511.d22f1bfc.png";